import { subMonths } from 'date-fns';
import { create } from 'zustand';

const today = new Date();

type FinancesPageFilterType = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        apartmentId?: {
            id: string;
            name?: string;
        }[];
    };
    setFilter: (filter: Partial<FinancesPageFilterType['filter']>) => void;
    resetFilter: () => void;
};

const defaultState: FinancesPageFilterType['filter'] = {
    startDate: subMonths(today, 5),
    endDate: today,
    apartmentId: [],
};

export const useFinancesPageFilter = create<FinancesPageFilterType>((set) => ({
    filter: { ...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({
            filter: { ...defaultState },
        });
    },
}));
